import React, { useState } from 'react'
import { Field } from 'formik'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'

import Input from 'components/Forms/FormElements/Input'
import Checkbox from 'components/Forms/FormElements/Checkbox'
import FormElementGroup from 'components/FormElements/FormElementGroup'
import UserEditMessage from './UserEditMessage/UserEditMessage'
import AppWindowBreakpoints from 'components/Util/WindowBreakpoints/AppWindowBreakpoints'
import RadioGroup from 'components/Forms/FormElements/RadioGroup'

const UserOwnInfoDataSection = () => {
    const location = useLocation()
    const [query] = useState(queryString.parse(location.search))
    const { t } = useTranslation('editProfile')

    return (
        <div className="user-own-info-data-section">
            <h2 className="user-own-info-data-section__text">{t('editProfile:details.ownInfo.text')}</h2>
            <FormElementGroup cssClass="cols-1">
                <Field name="isShowPhoneNumber">
                    {props => (
                        <RadioGroup
                            {...props}
                            type="radio"
                            name="isShowPhoneNumber"
                            label={t('editProfile:details.ownInfo.fields.isShowPhoneNumber.label')}
                            options={[
                                { value: true, name: t('editProfile:details.ownInfo.fields.isShowPhoneNumber.options.yes') },
                                { value: false, name: t('editProfile:details.ownInfo.fields.isShowPhoneNumber.options.no') },
                            ]}
                            onChange={(e) => {
                                const isVisible = e.target.value === 'true'

                                // Push to dataLayer
                                window.dataLayer.push({
                                    event: 'toggle_phone_visibility',
                                    switch: isVisible ? 'on' : 'off'
                                })
                            }}
                            orientation="horizontal"
                            required={Boolean(query?.isVerificationProcess && !query?.redirectPath?.includes('aloita-kaupanteko'))}
                        />
                    )}
                </Field>
                {!query?.isVerificationProcess && (
                    <UserEditMessage
                        sectionType="UserOwnInfoDataWithPhoneNumverVisibility"
                    />
                )}
            </FormElementGroup>
            <FormElementGroup cssClass="cols-1">
                <Field
                    type="text"
                    name="preferredTimeOfContact"
                    component={Input}
                    label={t('editProfile:details.ownInfo.fields.preferredTimeOfContact.label')}
                    placeholder={t('editProfile:details.ownInfo.fields.preferredTimeOfContact.placeholder')}
                    strongLabel
                />
                <AppWindowBreakpoints
                    render={({ up }) => up('containerXS') ? null : <UserEditMessage sectionType="UserOwnInfoData" />}
                />
            </FormElementGroup>
            <FormElementGroup cssClass="cols-1">
                <Field name="allowDealerFavoriteListAccess">
                    {(props) => (
                        <Checkbox
                            {...props}
                            label={t('editProfile:details.ownInfo.fields.allowDealerFavoriteListAccess.label')}
                        />
                    )}
                </Field>
            </FormElementGroup>
        </div>
    )
}

export default UserOwnInfoDataSection
